import {
	Container,
	ContainerPadding,
	TextAlignment,
	TokenTextAppearance,
	Text,
	Image,
	styled,
	ContainerGutter,
	TokenTextColor,
	CTA,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import { Logo } from '@volkswagen-onehub/icons-core';
import { HuchaVentaValues } from '../../../shared/models/hucha-values';
import { HuchaIcon } from '../../assets/hucha-icon';
import { HuchaDisclaimer1Content } from '../disclaimers/hucha-disclaimer1-content';
import { PdfHuchaStandardCard } from './pdf-card/pdf-hucha-standard-card/pdf-hucha-standard-card';
import { COLOR_TOKEN } from '../../../../../../helpers/color-tokens';

const TopContainer = styled(Container)`
	background-color: ${COLOR_TOKEN.button.primary.default};
`;

const SVGContainer = styled.div`
	& > svg {
		width: 56px;
	}
`;

const VouchersHuchaContainer = styled.div`
	position: absolute;
	bottom: -10%;
	left: 50%;
	transform: translateX(-50%);
	z-index: 2;
	width: max-content;
	padding: var(--size-dynamic0020) var(--size-dynamic0050);
	background-color: ${COLOR_TOKEN.button.primary.default};
	border: 1px solid ${COLOR_TOKEN.content.inverted};
	border-radius: 16px;
`;

const RelativeContainer = styled.div`
	position: relative;
`;

const CTAStyled = styled(CTA)`
	background-color: ${COLOR_TOKEN.button.primary.default};
	width: 64px;
	height: 64px;

	& svg {
		width: 56px;
		height: 56px;
	}
`;

export const PdfHuchaStandard: React.FC<{
	huchaValues: HuchaVentaValues;
}> = ({ huchaValues }) => {
	return (
		<>
			<TopContainer stretchContent>
				<Container padding={ContainerPadding.dynamic0100} verticalAlign={'center'}>
					<SVGContainer className="svg-container">
						<CTAStyled tag="button" emphasis="primary" icon={<Logo variant="default" />} />
					</SVGContainer>
				</Container>
				<Container
					horizontalAlign={'flex-end'}
					verticalAlign={'center'}
					padding={ContainerPadding.dynamic0100}
					gutter={ContainerGutter.static250}
				>
					<SVGContainer className="svg-container">
						<HuchaIcon />
					</SVGContainer>
					<Container wrap={'always'} horizontalAlign={'center'} verticalAlign={'center'}>
						<Text appearance={TokenTextAppearance.headline200} color={TokenTextColor.inverted} bold>
							Hucha{' '}
						</Text>
						<Text appearance={TokenTextAppearance.headline200} color={TokenTextColor.inverted}>
							Volkswagen
						</Text>
					</Container>
				</Container>
			</TopContainer>

			<Container padding={ContainerPadding.dynamic0200} stretchContent>
				<RelativeContainer>
					<Image
						// src="https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/img_pdf_renovadores_small.png"
						src="https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/img_pdf_renovadores_small.png"
						alt="Imagen hucha"
						style={{ borderRadius: '16px', objectFit: 'cover' }}
					/>

					<VouchersHuchaContainer className="voucher-hucha__container">
						<Container horizontalAlign={'center'} verticalAlign={'center'} padding={ContainerPadding.static350}>
							<Text
								appearance={TokenTextAppearance.headline300}
								color={TokenTextColor.inverted}
								textAlign={TextAlignment.center}
								bold
							>
								{huchaValues?.idUser}
							</Text>
						</Container>
					</VouchersHuchaContainer>
				</RelativeContainer>
			</Container>

			<Container
				padding={{
					top: ContainerPadding.static250,
					left: ContainerPadding.static400,
					right: ContainerPadding.static400,
				}}
				stretchContent
			>
				<PdfHuchaStandardCard dineroHucha={huchaValues?.dineroHucha ?? ''} />
			</Container>

			<Container
				padding={{
					right: ContainerPadding.grid001,
					bottom: ContainerPadding.dynamic0200,
					left: ContainerPadding.grid001,
				}}
				horizontalAlign={'center'}
				wrap={'always'}
			>
				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0100,
					}}
				>
					<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
						Nombre: <Text bold>{huchaValues?.name + ' ' + huchaValues?.apellido1 + ' ' + huchaValues?.apellido2}</Text>
					</Text>

					<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
						E-mail: <Text bold>{huchaValues?.email}</Text>
					</Text>

					<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
						Ahorro acumulado: <Text bold>{huchaValues?.dineroHucha}€</Text>
					</Text>

					<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
						Fecha de descarga: <Text bold>{huchaValues?.fechaDescarga}</Text>
					</Text>

					<Container
						wrap={'always'}
						padding={{
							top: ContainerPadding.dynamic0150,
						}}
						verticalAlign={'center'}
						horizontalAlign={'center'}
					>
						<Text appearance={TokenTextAppearance.copy100} textAlign={TextAlignment.center}>
							Este código es únicamente para ti y es necesario presentarlo en el punto de venta para disfrutarlo.
						</Text>
					</Container>
					<Container
						wrap={'always'}
						padding={{
							top: ContainerPadding.dynamic0270,
						}}
						verticalAlign={'center'}
						horizontalAlign={'center'}
					>
						<HuchaDisclaimer1Content textGutter={ContainerGutter.static200} />
					</Container>
				</Container>
			</Container>
		</>
	);
};
